import metaLogo from '../../assets/logos/meta.jpg'
import googleAdsLogo from '../../assets/logos/google-ads.jpg'
import tradeDeskLogo from '../../assets/logos/trade-desk.png'
import bingAdsLogo from '../../assets/logos/bing-ads.png'
import googleDv360Logo from '../../assets/logos/google-dv360.png'
import snapchatLogo from '../../assets/logos/snapchat.png'
import tiktokLogo from '../../assets/logos/tiktok.png'
import pinterestLogo from '../../assets/logos/pinterest.png'
import redditLogo from '../../assets/logos/reddit.png'

export const DISTRIBUTION_DESTINATIONS = [
  { value: 'Meta', label: 'Meta', sublabel: 'Custom Audiences', img: metaLogo, color: '#0866FF' },
  { value: 'Google Ads', label: 'Google Ads', sublabel: 'Customer Match', img: googleAdsLogo, color: '#4285F4' },
  { value: 'The Trade Desk', label: 'The Trade Desk', sublabel: 'Audiences - Data API', img: tradeDeskLogo, color: '#2AB27B' },
  { value: 'Bing Ads', label: 'Bing Ads', sublabel: 'Audiences - Customer Match', img: bingAdsLogo, imgFit: 'contain', color: '#008373' },
  { value: 'Google DV360', label: 'Google DV360', sublabel: 'Customer Match', img: googleDv360Logo, imgFit: 'contain', color: '#34A853' },
  { value: 'Yahoo!', label: 'Yahoo!', sublabel: 'Audiences', icon: 'fa-brands fa-yahoo', color: '#6001D2' },
  { value: 'LinkedIn', label: 'LinkedIn', sublabel: 'DMP Segment Audience', icon: 'fa-brands fa-linkedin', color: '#0A66C2' },
  { value: 'Snapchat', label: 'Snapchat', sublabel: 'Audiences - Customer Lists', img: snapchatLogo, color: '#FFFC00' },
  { value: 'Tiktok', label: 'Tiktok', sublabel: 'Customer File Audience', img: tiktokLogo, color: '#000000' },
  { value: 'Pinterest', label: 'Pinterest', sublabel: 'Customer List Audience', img: pinterestLogo, color: '#E60023' },
  { value: 'Reddit Ads', label: 'Reddit Ads', sublabel: 'Audiences', img: redditLogo, color: '#FF4500' },
  { value: 'Generic', label: 'Generic', sublabel: 'SFTP Destination', icon: 'fa-solid fa-server', color: '#6C757D' },
]

const FALLBACK_ICON = 'fa-solid fa-plug'
const FALLBACK_COLOR = '#6C757D'

export function getDistributionDestinationDisplay(value) {
  const known = DISTRIBUTION_DESTINATIONS.find((dest) => dest.value === value)
  if (known) return known
  return { value, label: value || '-', sublabel: '', icon: FALLBACK_ICON, color: FALLBACK_COLOR }
}
